export const dashboardFinancialBalanceFragment = `
    folderId
    personId
    client
    previousPaid
    previousUnpaid
    currentPaid
    currentUnpaid
`;

export const dashboardPerformedWorkFragment = `
    date
    userId
    worker
    statutoryCount
    informativeCount
    facultativeCount
`;

export const dashboardWorkedHoursFragment = `
    date
    userId
    worker
    workedMinutes
`;

export const dashboardWorkersWorkedHoursFragment = `
    serviceId
    userId
    worker
    workedMinutes
`;

export const dashboardWorkerResourceFragment = `
    id
    name
    surname
    titleBeforeName
    titleAfterName
    employments {
        id
        organizationId
        serviceId
        dateFrom
        dateTo
    }
    workplaces {
        id
        name
        validFrom
        validTo
        active
        hours {
            type
            day
            from
            to
        }
    }
`;
